export default __webpack_public_path__ + "static/genopets-5-a-0d70847dddf453c7858ab1d58a399423.webp";